export default __webpack_public_path__ + "static/media/1.92a98753.jpg";